import { useQuery } from "@tanstack/react-query";
import { getGallery } from "../gallery";
import type { Gallery } from "../gallery";

export function useGallery() {
  return useQuery<Gallery[]>({
    queryKey: ["gallery"],
    queryFn: getGallery,
  });
}
